/*
  Cart count badge for the bottom mobile nav.

  That nav is an app block (ai-mobile-nav-*), so its markup cannot be edited in
  the theme and it ships no count of its own — the badge is attached at runtime
  instead. [data-nav-item="cart"] is the hook because the app's own script
  relies on that attribute, which makes it the most stable selector available;
  the class names all carry a generated hash that would change if the block is
  regenerated.

  Loaded with defer AFTER constants.js and pubsub.js so `subscribe` and
  PUB_SUB_EVENTS exist. Both are bare top-level declarations in classic
  scripts, so they are in global scope but NOT properties of window — hence the
  `typeof` guards rather than `window.x` checks.
*/
(function () {
  var SELECTOR = '[data-nav-item="cart"]';

  function paint(count) {
    var n = parseInt(count, 10);
    if (isNaN(n) || n < 0) n = 0;

    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (link) {
      var badge = link.querySelector('.pl-cart-badge');

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'pl-cart-badge';
        // The count is already announced through the link's aria-label below,
        // so the badge itself is decorative to screen readers.
        badge.setAttribute('aria-hidden', 'true');

        var icon = link.querySelector('svg');
        var host = icon && icon.parentNode ? icon.parentNode : link;
        host.classList.add('pl-cart-badge-host');
        host.appendChild(badge);
      }

      badge.textContent = n > 99 ? '99+' : String(n);
      badge.hidden = n === 0;
      link.setAttribute('aria-label', n === 0 ? 'Cart' : 'Cart, ' + n + ' items');
    });
  }

  // Fallback for cart changes that report no usable count.
  function refresh() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        paint(cart.item_count);
      })
      .catch(function () {
        /* leave the last known count in place */
      });
  }

  paint(window.plCartCount);

  // Dawn publishes this whenever the cart changes without a page load — the
  // quantity stepper, quick add, the product form and the cart page all fire it.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && typeof data.item_count === 'number') paint(data.item_count);
      else refresh();
    });
  }

  // The nav is injected by an app and may mount after this script runs, so
  // retry briefly until the badge is attached. Gives up after ~5s either way.
  var attempts = 0;
  var poll = setInterval(function () {
    attempts += 1;
    if (document.querySelector(SELECTOR + ' .pl-cart-badge') || attempts > 20) {
      clearInterval(poll);
      return;
    }
    paint(window.plCartCount);
  }, 250);
})();
